import { FieldButtonProps } from './FieldButton.type'

import { Container, Input, Button } from './FieldButton.styles'

import { isPositiveInteger } from './FieldButton.utils'

const MAX_INPUT_LENGTH = 3

const FieldButton = ({
  children,
  heightClass = 'regular',
  value,
  onChange,
  disabled,
  nonFocusable,
  tabIndex,
  variant = 'primary',
  onClick,
  pulseAnimate
}: FieldButtonProps) => {
  const buttonDisabled = !value.length

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target

    if (
      (value.length > MAX_INPUT_LENGTH || !isPositiveInteger(value)) &&
      value !== ''
    ) {
      return
    }

    onChange(value)
  }

  return (
    <Container {...{ heightClass, variant, pulseAnimate }}>
      <Input
        {...{ value, disabled, heightClass, variant }}
        tabIndex={nonFocusable ? -1 : tabIndex}
        onChange={handleChange}
        placeholder='0'
      />
      <Button
        {...{ heightClass, variant, onClick }}
        disabled={disabled || buttonDisabled}
        focusable={!nonFocusable}
        tabIndex={nonFocusable ? -1 : tabIndex}
        pulseAnimate={undefined}
      >
        {children}
      </Button>
    </Container>
  )
}

export default FieldButton
